import { render, staticRenderFns } from "./InsuranceFormality.vue?vue&type=template&id=540c5725&scoped=true"
import script from "./InsuranceFormality.vue?vue&type=script&lang=js"
export * from "./InsuranceFormality.vue?vue&type=script&lang=js"
import style0 from "./InsuranceFormality.vue?vue&type=style&index=0&id=540c5725&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "540c5725",
  null
  
)

export default component.exports